import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AbilityContext } from '../../../../components/Ability'
import NotFound from '../../../NotFound'
import ShopeeLogin from './Features/ShopeeLogin'
import ShopeeOrderList from './Features/ShopeeOrderList'


const ShopeePage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/login"
        element={
          ability.can('read', 'Users') ? <ShopeeLogin /> : <NotFound />
        }
      />
      <Route
        path="/order"
        element={
          ability.can('read', 'Users') ? <ShopeeOrderList /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default ShopeePage
